// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/medical.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/medical/medical-expiry.js';

mount([g0]);
